module.exports = __webpack_public_path__ + "static/img/36.802edd3.png";